export default {
  // The blog's title as it appears in the layout header, and in the document
  // <title> tag.
  title: "Welcome to Antonia's Nicolaou Personal Blog",
  logo: "../assets/logo.png",
  author: "Antonia Nicolaou",
  image: "../assets/logo.png",
  description:
    "Through this blog I share my experiences and the things that I’ve learned!",

  // The number of posts to a page on the site index.
  indexPageSize: 10
};
